import React from "react";

export const LazyUnusualInstrumentsPage = React.lazy(
    () =>
        import(
            /* webpackChunkName: "UnusualInstrumentsPage" */ "./UnusualInstrumentsPage"
        )
);
